/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { useState } from "react";
import SoftBadge from "components/SoftBadge";

// Badges
const stoppedStatus = (
  <SoftBadge variant="contained" color="dark" size="xs" badgeContent="Stopped" container />
);
const runningStatus = (
  <SoftBadge variant="contained" color="secondary" size="xs" badgeContent="Running" container />
);

function SignalsCell({
  id,
  el,
  handleKeyAction,
  handleSnapshotAction,
  handleFeedAction,
  handleUpdateBlockBetsAction,
  allowBlockBets,
}) {
  const [keyTooltip, setKeyTooltip] = useState(null);
  const [snapshoted, setSnapshoted] = useState(null);
  const [running, setRunning] = useState(null);
  const [stopped, setStopped] = useState(null);

  /**
   *
   * @param {*} param0
   * @returns
   */
  function makeStatusCell(status) {
    return status == "play" ? runningStatus : stoppedStatus;
  }

    const snapShot = () => {
    setSnapshoted({ date: new Date() });
    handleSnapshotAction();
  };
  const updateBlockBets = (e) => {
    e.preventDefault();
    handleUpdateBlockBetsAction();
  };
  const startConsume = (e) => {
    e.preventDefault();
    setRunning({ date: new Date() });
    handleFeedAction(e, "start");
  };
  const stopConsume = (e) => {
    e.preventDefault();
    setStopped({ date: new Date() });
    handleFeedAction(e, "stop");
  };

  return (
    <SoftBox display="flex" alignItems="center">
      {/* <>{makeStatusCell("play")}</> */}
      <SoftBox mx={2}>
        <SoftTypography
          variant="body1"
          color={running ? "success" : "secondary"}
          sx={{ cursor: "pointer", lineHeight: 0 }}
          className={el.status == "Disabled" ? "select-disabled div" : ""}
          disabled={el.status == "Disabled"}
        >
          <Tooltip
            title={running ? "Start Feed Signal sent on:  " + running.date : "Start Consuming Feed"}
            placement="top"
          >
            <Icon
              onClick={(e) => (el.status == "Enabled" ? startConsume(e) : null)}
              className="play-action"
            >
              play_circle_filled_white_outlined_icon
            </Icon>
          </Tooltip>
        </SoftTypography>
      </SoftBox>
      <SoftBox mx={2}>
        <SoftTypography
          variant="body1"
          color={stopped ? "error" : "secondary"}
          sx={{ cursor: "pointer", lineHeight: 0 }}
          className={el.status == "Disabled" ? "select-disabled div" : ""}
          disabled={el.status == "Disabled"}
        >
          <Tooltip
            title={stopped ? "Stop Feed Signal sent on:  " + stopped.date : "Stop Consuming Feed"}
            placement="top"
          >
            <Icon
              onClick={(e) => (el.status == "Enabled" ? stopConsume(e) : null)}
              className="stop-action"
            >
              stop_circle_outlined_icon
            </Icon>
          </Tooltip>
        </SoftTypography>
      </SoftBox>
      <SoftBox mx={2}>
        <SoftTypography
          variant="body1"
          color={snapshoted ? "primary" : "secondary"}
          className={el.status == "Disabled" ? "select-disabled div" : "snapshot-action"}
          sx={{ cursor: "pointer", lineHeight: 0 }}
          disabled={el.status == "Disabled"}
        >
          <Tooltip
            title={snapshoted ? "Snapshot sent on:  " + snapshoted.date : "Send Snapshot"}
            placement="top"
          >
            <Icon onClick={el.status == "Enabled" ? snapShot : null}>camera</Icon>
          </Tooltip>
        </SoftTypography>
      </SoftBox>

      <SoftBox mx={2}>
        <SoftTypography
          variant="body1"
          color={el.block_bets ? "primary" : "secondary"}
          className={el.status == "Disabled" ? "select-disabled div" : "block-bets-action"}
          style={{ display: allowBlockBets ? "" : "none" }}
          sx={{ cursor: "pointer", lineHeight: 0 }}
          disabled={el.status == "Disabled"}
        >
          <Tooltip title={el.block_bets ? "Unblock Bets" : "Block Bets"} placement="top">
            <Icon onClick={el.status == "Enabled" ? updateBlockBets : null}>
              {el.block_bets ? "money_off_outlined_icon" : "attach_money_outlined_icon"}
            </Icon>
          </Tooltip>
        </SoftTypography>
      </SoftBox>
    </SoftBox>
  );
}

// Typechecking props of the CreateTemplate
SignalsCell.propTypes = {
  id: PropTypes.number,
  el: PropTypes.object,
  handleKeyAction: PropTypes.func,
  handleSnapshotAction: PropTypes.func,
  handleFeedAction: PropTypes.func,
  handleUpdateBlockBetsAction: PropTypes.func,
  allowBlockBets: PropTypes.bool,
};

export default SignalsCell;
